import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {getCompanySubdomain} from '../../../../store/data/company/companySelectors';
import {getUserAlias} from '../../../../store/data/teammates/teammatesSelectors';
import {
  getDraftSchedulingLinkId,
  getDraftSchedulingLinkName,
  getDraftSchedulingLinkSlug,
  getOtherSlugs,
} from '../../../../store/panels/calendars/scheduling/calendarsPanelSchedulingSelectors';
import {CalendarsPanelId} from '../../../../store/panels/panelStateBase';
import {SchedulingLinkUrlSettings} from './schedulingLinkUrlSettings';

/*
 * Props.
 */

interface SchedulingLinkUrlSettingsContainerProps {
  panelId: CalendarsPanelId;
}

/*
 * Selectors.
 */

const getIsNewSchedulingLink = createSelector(getDraftSchedulingLinkId, (linkId) => linkId === undefined);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SchedulingLinkUrlSettingsContainerProps>()(() => ({
  isNewSchedulingLink: getIsNewSchedulingLink,
  name: getDraftSchedulingLinkName,
  slug: getDraftSchedulingLinkSlug,
  otherSlugs: getOtherSlugs,
  userAlias: getUserAlias,
  companySubdomain: getCompanySubdomain,
}));

export const SchedulingLinkUrlSettingsContainer = connect(mapStateToProps)(SchedulingLinkUrlSettings);
